/**
 * Tenant watchlist suppliers: watchlist item links to a unified Company (ticker = company_id).
 */

/** Returns supplier ticker (same as watchlist company_id). */
export const getTenantSupplierTicker = (item) => {
  const company = item?.company;
  const fromCompany =
    company?.ticker ||
    company?.company_id ||
    company?.companyId ||
    '';
  const fromWatchlist =
    item?.watchlistItem?.companyId ||
    item?.watchlistItem?.company_id ||
    item?.watchlist_item?.company_id ||
    '';
  return String(fromCompany || fromWatchlist || '').trim().toUpperCase();
};

/** @deprecated Use getTenantSupplierTicker */
export const getTenantSupplierId = getTenantSupplierTicker;

export const getTenantSupplierName = (item) => {
  const company = item?.company;
  if (!company) {
    const id = getTenantSupplierId(item);
    return id || '';
  }
  const fromCompany =
    company.name ||
    company.company_name ||
    company.companyName ||
    company.legalName ||
    company.legal_name ||
    '';
  const id = getTenantSupplierId(item);
  return fromCompany || id || '';
};

export const getTenantSupplierTier = (item) => {
  const tier = item?.company?.tier;
  return tier != null && tier !== '' ? String(tier) : '';
};

export const getTenantSupplierLegalName = (item) => {
  const company = item?.company;
  return company?.legalName || company?.legal_name || '';
};

export const getTenantSupplierCountry = (item) => {
  const company = item?.company;
  return company?.country || '';
};

export const getTenantSupplierCriticality = (item) => {
  const company = item?.company;
  const score = company?.criticalityScore ?? company?.criticality_score;
  return score != null && score !== '' ? Number(score) : null;
};
